import { Http } from '@/core/axios'

// gp: globalPrefix 公共前缀
const accountHost = process.env.VUE_APP_ACCOUNT_HOST
const gp = '/selection'
const search = '/search/selection'
// params 转为query
function toQuery(url, params) {
  let urlParams = []
  Object.keys(params).forEach((key) => {
    // 如果值为空，则不传该属性
    if (params[key] || params[key] === 0 || params[key] === false) {
      urlParams.push(`${key}=${encodeURIComponent(params[key])}`)
    }
  })
  if (urlParams.length) {
    urlParams = url.includes('?') ? `${url}&${urlParams.join('&')}` : `${url}?${urlParams.join('&')}`
  } else {
    urlParams = url
  }
  return urlParams
}

const api = {
  // 不接入插件的埋点
  tracks(params, headers = {}) {
    return Http.post(`/tracks`, params, {}, headers)
  },
  // 用户信息
  user: {
    logout(dest) {
      return Http.delete(`${accountHost}/session?dest=${encodeURIComponent(dest)}`)
    },
    getUserInfo(headers = {}) {
      const config = {
        headers
      }
      return Http.get(`${accountHost}/users/info?role=0`, {}, config)
    },
    getLoginToken() {
      return Http.post(`${accountHost}/login_token`)
    },
    // 获取用户每日下载revit构件的次数
    getDownloadCount() {
      return Http.get(`/v1/shop_components/download/count`)
    },
    getUserDetail() {
      return Http.get(`${accountHost}/users/details`)
    },
    logoutPlugin(headers = {}) {
      const config = {
        headers
      }
      return Http.delete(`${accountHost}/authcode`, config)
    },
    ssoUrl(dest) {
      return Http.get(`${accountHost}/sso/url${toQuery('', dest)}`)
    },
  },
  download: {
    // 获取revit插件下载地址
    getRevitUrl() {
      return Http.get(`/plugins/latest/download_url`)
    },
    // 获取数维设计平台构件下载地址
    novaDownloadUrl(softwareCode, componentId, query) {
      const config = {}
      if (query.productId) {
        config.headers = { 'X-Product-Id': query.productId }
        delete query.productId
      }
      delete query.productId
      return Http.get(`/system/site/v1/softwares/${softwareCode}/system_components/${componentId}/download`, query, config)
    },
    // 获取revit平台构件下载地址
    revitDownloadUrl(componentId, query) {
      const config = {}
      if (query.productId) {
        config.headers = { 'X-Product-Id': query.productId }
        delete query.productId
      }
      delete query.productId
      return Http.get(`/v1/shop_components/${componentId}/download_url`, query, config)
    },
    // 获取通用平台构件下载地址
    generalDownloadUrl(componentId, query) {
      const config = {}
      if (query.productId) {
        config.headers = { 'X-Product-Id': query.productId }
        delete query.productId
      }
      return Http.get(`/general/v1/general_components/${componentId}/download_url`, query, config)
    },
  },
  // 品类/属性元数据
  classification: {
    // 获取品类列表
    getClassification(params) {
      return Http.post(`/gjk/data_standards/v2/classifications`, params)
    },
    // 获取品类下的属性
    getClassificationProperties(classification_code, params) {
      return Http.post(`/gjk/data_standards/site/v1/classifications/${classification_code}/properties`, params)
    },
  },
  // 个人项目相关
  project: {
    // 获得当前项目产品信息
    getCurrentProject() {
      return Http.get(`/private/v1/personal_projects/current`, {})
    },
    // 聚合当前项目品类列表
    getProjectCategoriesAgg(id) {
      return Http.get(`/private/v1/personal_projects/${id}/personal_products/gjw_categories/agg`, {})
    },
    // 获取当前项目已选产品
    getProductList(id, query) {
      return Http.get(`/private/v1/personal_projects/${id}/personal_products/page`, query)
    },
    // 选中产品
    selectProduct(id, params) {
      return Http.post(`/private/v1/personal_projects/${id}/personal_products`, params)
    },
    // 选中产品传给机电
    selectProductGcs(id) {
      return Http.get(`/selection/products/${id}/selected`)
    },
    // 取消选中产品
    cancelSelectProduct(id, data) {
      return Http.delete(`/private/v1/personal_projects/${id}/personal_products`, data)
    },
    // 导出选中产品-Excel
    exportProduct(id, params) {
      return Http.post(`/private/v1/personal_projects/${id}/personal_products/export`, params)
    },
    // 轮询导出的excel地址
    getExportUrl(id, query) {
      return Http.get(`/private/v1/personal_projects/${id}/personal_products/export/url`, query)
    },
    // 编辑已选产品设计属性
    updateProductDesignProps(projectId, personalProductId, params) {
      return Http.patch(`/private/v1/personal_projects/${projectId}/personal_products/${personalProductId}/design_properties`, params)
    },
    // 编辑已选产品设备编号
    updateProduct(projectId, personalProductId, params) {
      return Http.patch(`/private/v1/personal_projects/${projectId}/personal_products/${personalProductId}`, params)
    },
  },
  // 产品详情
  products: {
    // 选择备选（风机选盘）
    parameter_values(params) {
      return Http.post(`${search}/v1/products/parameter_values?gjw_category_code=C000006&parameter_filter=${params.parameter_filter}`, params.paramsObj)
    },
    // 选择备选（室内机）
    parameter_Undoor_values(params) {
      return Http.post(`${search}/v1/products/parameter_values?gjw_category_code=C000005&parameter_filter=${params.parameter_filter}`, params.paramsObj)
    },
    // 选择备选（末端风口）
    parameter_AirOutlet_values(params) {
      return Http.post(`${search}/v1/products/parameter_values?gjw_category_code=C000012&parameter_filter=${params.parameter_filter}`, params)
    },
    // 获取最新选型结果
    getMulti_room(gjw_category_code, params) {
      return Http.post(`${search}/v1/products/multi_room/${gjw_category_code}`, params)
    },
    // 获取产品聚合的筛选属性
    getAggProperties(params) {
      return Http.post(`${search}/v1/products/search_properties_agg`, params)
    },
    // 获取产品聚合的产品系列
    getAggProductSeries(params) {
      return Http.post(`${search}/v1/products/product_series/agg`, params)
    },
    // 获取品类下的所有品牌
    getAggBrands(params) {
      return Http.post(`${search}/v2/brands/agg`, params)
    },
    // 获取所有品牌(筛选条件)
    getSelectionBrands(query) {
      return Http.get(`${search}/v1/brands/agg`, query)
    },
    // 获取品类下的共享参数定义（R插件布置时需要）
    getShareParamDefinitions(query) {
      return Http.get(`/private/v1/share_param_definitions`, query)
    },
    // 获取R插件产品布置时的相关信息（包括共享参数值）
    getArrangementInfo(params) {
      return Http.post(`/private/v1/personal_projects/arrangement_info`, params)
    },
    // 获取G插件产品布置时的相关信息
    getProductParams(params) {
      return Http.post(`${gp}/products/product_params`, params)
    },
    // 获取产品列表
    list(params) {
      return Http.post(`${search}/v1/products/query`, params)
    },
    // 检测是否存在用户反馈访问记录
    existFeedbackVisit(query = {}) {
      return Http.get(`${gp}/feedback_visits/exist`, query)
    },
    // 用户反馈
    feedback(params = {}) {
      return Http.post(`/feedback`, params)
    },
    detail(id) {
      return Http.get(`${gp}/products/${id}`)
    },
    relatedComponents(id, query = {}) {
      return Http.get(`${gp}/products/${id}/product_components`, query)
    },
    relatedBlocks(id) {
      return Http.get(`${gp}/products/${id}/cad_blocks`)
    },
    blockDownloadUrl(id) {
      return Http.get(`${gp}/cad_blocks/${id}/download_url`)
    },
    // 获取产品曲线性能点
    curveData(id) {
      return Http.get(`${gp}/products/${id}/product_curves`)
    },
    // 获取产品工况相似曲线和运行点
    operateData(id, params) {
      return Http.post(`${gp}/products/${id}/work_condition_curves`, params)
    },
    properties(id) {
      return Http.get(`${gp}/products/${id}/product_property_values`)
    },
    // 获取产品的运行点数据
    getRuntimeData(id, params) {
      return Http.post(`${gp}/products/${id}/runtime_points`, params)
    },
    // 获取产品的性能数据
    getPerformanceProperties(id) {
      return Http.get(`${gp}/products/${id}/product_performance_properties`)
    },
    // 批量获取产品关联手册
    getBatchSamples(params) {
      return Http.post(`${gp}/products/product_sample_mappings`, params)
    },
  },
  // 查手册
  documents: {
    // 手册查询
    getDocuments(params) {
      return Http.post(`${gp}/product/document/list`, params)
    },
    // 品牌详细信息查询
    getBrands(params) {
      return Http.get(`${gp}/product/get_brand_info`, params)
    },
    // 获取手册联系方式
    getContact(id) {
      return Http.get(`${gp}/product/contactInfoBySupplierId/${id}`)
    },
    // 获取产品手册预览地址
    sampleUrl(sample_id) {
      return Http.get(`${gp}/products/samples/${sample_id}/preview_url`)
    },
  },
  // 材料库
  material: {
    // 获取材料品类
    getCategories() {
      const query = {
        resource_type: 'STANDARD_MATERIAL'
      }
      return Http.get(`/gjk/data_standards/site/v1/classifications`, query)
    },
    // 获取品类的数量聚合
    getCategoryAgg() {
      return Http.get(`/search/material/v1/materials/gjw_category_agg`)
    },
    // 获取列表数据
    list(params) {
      return Http.post(`/search/material/v1/materials/query`, params)
    },
  },
  // 商品相关
  goods: {
    list(body) {
      return Http.post('/selection/goods', body)
    }
  },
  // 地区相关
  areas: {
    list() {
      return Http.get('/selection/areas')
    }
  },
  generalComponent: {
    detail(cid) {
      return Http.get(`/system/v1/general_components/${cid}`, {
        analyzer_i_o_mark: 'visitDetail'
      })
    }
  },
  gcsComponent: {
    detail(softwareCode, cid, softwareVersion, query) {
      return Http.get(`/system/site/v1/softwares/${softwareCode}/system_components/${cid}`, {
        analyzer_i_o_mark: 'visitDetail',
        software_version: softwareVersion,
        ...query
      })
    },
    properties(softwareCode, cid, fid, version) {
      return Http.get(`/system/site/v1/softwares/${softwareCode}/system_components/${cid}/family_type?family_type_id=${fid}&software_version=${version}`)
    },
    placeholders(softwareCode, cid, softwareVersion) {
      return Http.get(`/system/site/v1/softwares/${softwareCode}/system_components/${cid}/placeholders?software_version=${softwareVersion}`)
    },
  },
  revitComponent: {
    detail(cid) {
      return Http.get(`/revit/v4/public_components/${cid}?analyzer_i_o_mark=visitDetail`)
    },
    properties(cid, name) {
      return Http.get(`/v1/shop_components/${cid}/family_groups?family_type_name=${name}`)
    },
    viewToken(cid) {
      return Http.get(`/v1/shop_components/${cid}/view_token`)
    }
  },
  // 模块库
  module: {
    optionsAgg(query) {
      return Http.get(`/system/v4/space_g_modules/agg`, query)
    },
    list(params) {
      return Http.post(`/system/v4/space_g_modules/page`, params)
    },
    detail(id) {
      return Http.get(`/system/v4/space_g_modules/${id}`)
    },
    // 与插件对接，将完整的接口地址传给插件，由插件发送接口请求
    downloadUrlInterface(id) {
      return `${process.env.VUE_APP_BASE_API}/system/v4/space_g_modules/${id}/download_url`
    },
  },
  // 模板库
  scheme: {
    list(query) {
      return Http.get(`/system/site/v1/templates`, query)
    },
    detail(id) {
      return Http.get(`/system/site/v1/templates/${id}/detail`)
    },
    downloadUrl(id) {
      return Http.get(`/system/site/v1/templates/${id}/download_url`)
    },
  },
  // 构件库
  components: {
    suggestions(query) {
      return Http.get(`/search/v3/public_components/suggestions`, query)
    },
    categroies(filters) {
      const softwareCode = filters.softwareCode
      if (softwareCode === 'AppDeco') {
        return Http.post('/search/v2/public_components/gjw_categories', filters)
      } else if (softwareCode === 'AppGbr') {
        const softwareCode = filters.softwareCode
        return Http.post(`/v2/softwares/${softwareCode}/system_categories`, filters)
      } else {
        const config = {
          headers: { 'x-plugin': true }
        }
        return Http.get('/search/v4/public_components/gjw_categories', filters, config)
      }
    },
    searchProperties(body) {
      return Http.post('/search/v3/public_components/search_properties_agg', body)
    },
    // 获取构件列表数据
    list(params) {
      const softwareCode = params.softwareCode
      // 装饰软件
      if (softwareCode === 'AppDeco') {
        return Http.post(`/search/v2/public_components/list`, params)
      } else {
        const config = {
          headers: { 'x-plugin': true }
        }
        if (softwareCode === 'AppGbr') {
          params.softwareCategoryCode = params.gjw_category_id ? params.gjw_category_id + '' : null
          params.gjwCategoryId = null
          params.gjw_category_id = null
        }
        return Http.post(`/search/v3/public_components/search`, params, config)
      }
    },
    versions(platformCode, softwareCode, componentId) {
      if (platformCode === 'NOVA_DESIGN') {
        const gSegment = `/system/site/v1/softwares/${softwareCode}/system_components/${componentId}`
        return Http.get(`${gSegment}/software_versions`)
      } else if (platformCode === 'GENERAL') {
        const cSegment = `/general/v1/general_components/${componentId}`
        return Http.get(`${cSegment}/software_versions`)
      } else {
        const rSegment = `/revit/v4/public_components/${componentId}`
        return Http.get(`${rSegment}/software_versions`)
      }
    },
    favorite(componentId, params) {
      return Http.post(`/favourite/component/${componentId}`, params)
    },
    favoriteCancel(componentId) {
      return Http.delete(`/favourite/component/${componentId}`)
    },
    isFavoriteBatch(ids) {
      return Http.post(`/personal_favourite/is_favourite_batch`, ids)
    },
  },
  // 做法库
  practice: {
    list(params) {
      return Http.get('/system/v1/practice/list', params)
    },
    categroies() {
      return Http.get('/system/v1/practice/agg_category')
    },
    features() {
      return Http.get('/system/v1/practice/agg_feature')
    },
    // 获取载入所需参数的信息
    loadParamsInfo(practice_id) {
      return Http.get(`/system/v1/practice/${practice_id}`)
    }
  },
  // 专题场景库
  scene: {
    list(query) {
      return Http.get(`/system/api_general/v2/scenes`, query)
    },
    detail(id) {
      return Http.get(`/api_general/scenes/${id}`)
    },
    component(params) {
      return Http.post(`search/v3/public_components/search`, params)
    },
  },
}

export default {
  api,
  install: (Vue) => {
    Vue.prototype.$api = api
  },
  inject: (Store) => {
    Store.prototype.$api = api
  }
}
